export default {
  title: 'Sistema eFactura',
  unavailable: 'Desculpe, mas a URL que você solicitou não está disponível. Por favor, entre em contato com o seu fornecedor.'
}